module.exports = __webpack_public_path__ + "img/merchant-sign-up.52b019e1.webp";